exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pixel-articles{display:flex;flex-direction:column}.pixel-articles .pixel-article{margin-top:8px;align-self:stretch;display:flex;flex-direction:column;align-items:center;font-size:14px}.pixel-articles .pixel-article .details{margin-top:4px}.pixel-articles .pixel-article .details .license{font-size:12px}", ""]);

